import Grid from "@mui/material/Grid2";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import { FieldValues, Path, TextFieldElement, TextFieldElementProps, useFormContext } from "react-hook-form-mui";

interface IProps<T extends FieldValues> extends TextFieldElementProps {
    name: Path<T>
    label?: string
    readOnly?: boolean
    startAdornment?: React.ReactNode
    endAdornment?: React.ReactNode
    decimalLength?: number;
}

export default function NumberInputField<T extends FieldValues>(props: IProps<T>) {
    const { setValue } = useFormContext<T>()

    return (
        <Grid container size={12}>
            <Grid size={8} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant={props.decimalLength ? undefined : "body1"}>{props.label}</Typography>
            </Grid>
            <Grid size={4}>
                <TextFieldElement
                    name={props.name}
                    type="number"
                    inputMode="decimal"
                    onBlur={(event) => {
                        if (!props.readOnly) {
                            const inputValue = event.target.value.trim();
                            if (inputValue === "" || inputValue === "-" || inputValue === ".") {
                                setValue(props.name, null as any, { shouldValidate: true });
                            } else {
                                const numberValue = Number(inputValue);
                                if (!Number.isNaN(numberValue)) {
                                    setValue(props.name, numberValue.toFixed(props.decimalLength ?? 2) as any, { shouldValidate: true });
                                }
                            }
                        }
                    }}
                    InputProps={{
                        readOnly: props.readOnly,
                        startAdornment: props.startAdornment ? <InputAdornment position="start">{props.startAdornment}</InputAdornment> : undefined,
                        endAdornment: props.endAdornment ? <InputAdornment position="end">{props.endAdornment}</InputAdornment> : undefined,
                        ...props.InputProps,
                    }}
                    transform={{
                        input: (v: number | null) => (props.readOnly ? v == null ? "" : v.toFixed(props.decimalLength ?? 2) : v),
                    }}
                />
            </Grid>
        </Grid>
    );
}